<!-- SocialSection.vue -->
<template>
  <section class="social-section">
    <h2 class="section-title">{{ title }}</h2>

    <div v-if="items.length === 0 && !loading" class="empty-state">
      Nothing here yet
    </div>

    <ul class="item-list">
      <li v-for="item in items" :key="item.uid" class="item-row" @click="$emit('showProfile', item)">
        <img
          v-if="item.profilImgMini1"
          :src="bsrImg+item.profilImgMini1"
          class="avatar"
          alt=""
        />
        <div v-else class="avatar avatar-placeholder">
          <svg viewBox="0 0 24 24" fill="currentColor" width="20" height="20">
            <path d="M12 12a5 5 0 1 0 0-10 5 5 0 0 0 0 10Zm0 2c-4 0-8 2-8 5v1h16v-1c0-3-4-5-8-5Z" />
          </svg>
        </div>

        <div class="item-info">
          <span class="pseudo">{{ item.pseudo }}</span>
          <span class="likes">
            <svg viewBox="0 0 24 24" fill="currentColor" width="12" height="12">
              <path d="M2 21h4V9H2v12ZM22 10a2 2 0 0 0-2-2h-6.31l.95-4.57.03-.32a1.5 1.5 0 0 0-.44-1.06L13.17 1 7.59 6.59A2 2 0 0 0 7 8v11a2 2 0 0 0 2 2h9a2 2 0 0 0 1.84-1.21l3.02-7.05c.09-.23.14-.47.14-.74v-2Z" />
            </svg>
            {{ item.likes }} likes
          </span>
        </div>

        <button
          v-if="!item.isSelf"
          class="follow-btn"
          :class="{ following: item.isFollowing }"
          @click.stop="$emit('toggle-follow', { uid: item.uid, isFollowing: item.isFollowing })"
        >
          {{ item.isFollowing ? 'Unfollow' : 'Follow' }}
        </button>
      </li>
    </ul>

    <button
      v-if="hasMore"
      class="see-more-btn"
      :disabled="loading"
      @click="$emit('load-more')"
    >
      {{ loading ? 'Loading...' : 'See more' }}
    </button>
  </section>
</template>

<script setup>
/* eslint-disable no-undef */
import { useStore } from 'vuex'

const store = useStore()

const bsrImg = store.state.baseUrl + "images/";
defineProps({
  title: { type: String, required: true },
  items: { type: Array, required: true},
  loading: { type: Boolean, default: false },
  hasMore: { type: Boolean, default: true },
});
defineEmits(['load-more', 'toggle-follow', 'showProfile']);
</script>

<style scoped>
.social-section {
  background: #0f1526;
  border-radius: 12px;
  padding: 16px;
}

.section-title {
  color: #ffffff;
  font-size: 15px;
  font-weight: 700;
  margin: 0 0 12px;
}

.empty-state {
  color: #6b7280;
  font-size: 14px;
  padding: 12px 0;
}

.item-list {
  list-style: none;
  margin: 0;
  padding: 0;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.item-row {
  display: flex;
  align-items: center;
  gap: 12px;
  background: #131a30;
  border: 1px solid #1e2740;
  border-radius: 10px;
  padding: 10px 14px;
  cursor: pointer;
}

.avatar {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  object-fit: cover;
  border: 1px solid #2dd4f0;
  flex-shrink: 0;
}

.avatar-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  background: #1c2440;
  color: #6b7280;
}

.item-info {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
}

.pseudo {
  color: #ffffff;
  font-weight: 600;
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.likes {
  display: flex;
  align-items: center;
  gap: 4px;
  color: #6b7280;
  font-size: 12px;
  margin-top: 2px;
}

.follow-btn {
  flex-shrink: 0;
  padding: 8px 16px;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  border: 1px solid #2dd4f0;
  background: transparent;
  color: #2dd4f0;
  transition: background 0.15s ease;
}

.follow-btn:hover {
  background: rgba(45, 212, 240, 0.1);
}

.follow-btn.following {
  border-color: #2dd4f0;
  color: #2dd4f0;
}

.see-more-btn {
  width: 100%;
  margin-top: 12px;
  padding: 10px;
  border-radius: 8px;
  border: 1px solid #1e2740;
  background: #131a30;
  color: #9ca3af;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
}

.see-more-btn:hover {
  background: #1c2440;
}

.see-more-btn:disabled {
  opacity: 0.6;
  cursor: default;
}
</style>